import {
  ACTIVE_TEST_ICON,
  INACTIVE_TEST_ICON,
  DRAFT_TEST_ICON,
  COMPLETED_TEST_ICON,
  ACTIVE_TEST_LABEL,
  INACTIVE_TEST_LABEL,
  DRAFT_TEST_LABEL,
  COMPLETED_TEST_LABEL,
} from "./icons";
import {
  TEST_STATUS_ACTIVE,
  TEST_STATUS_INACTIVE,
  TEST_STATUS_DRAFT,
  TEST_STATUS_EDIT,
  TEST_STATUS_COMPLETED,
  TEST_TYPE_TT,
  TEST_TYPE_PD,
  TEST_TYPE_CS,
  TEST_DEVICE_TYPE_DESKTOP,
  TEST_DEVICE_TYPE_SMARTPHONE,
  CARD_TYPE_OPEN,
  CARD_TYPE_CLOSE,
  CARD_TYPE_HYBRID,
  MIN_CATEGORIES,
  MIN_CARDS,
  UNCLEAR_CATEGORY,
  QUEST_TYPE_TEXT,
  QUEST_TYPE_RADIO,
  QUEST_TYPE_CHECKBOX,
  // QUEST_TYPE_RATING,
  SURVEY_TYPE_SCREENER,
  SURVEY_TYPE_PRE,
  SURVEY_TYPE_POST,
  OPTION_TYPE_OTHERS,
  REQUIRE_EXPLANATION_NO,
  REQUIRE_EXPLANATION_YES,
  REQUIRE_EXPLANATION_OPTIONAL,
  RESPONSES,
  PRODUCT_CARD_SORTING,
  PRODUCT_TREE,
  PRODUCT_PARTICIPATORY,
} from "../actions/constants";
import dayjs from "dayjs";
import { shuffleArray, sortByKey } from "./common";
import CustomIcon from "../../../components/layouts/CustomIcon";

// Test Types
export const getAllTestStatus = () => {
  return [
    { value: TEST_STATUS_EDIT, text: "In-Edit", icon: <CustomIcon name='draft' />, label: DRAFT_TEST_LABEL },
    { value: TEST_STATUS_DRAFT, text: "Draft", icon: <CustomIcon name='draft' />, label: DRAFT_TEST_LABEL },
    { value: TEST_STATUS_ACTIVE, text: "Active", icon: <CustomIcon name='active' />, label: ACTIVE_TEST_LABEL },
    { value: TEST_STATUS_INACTIVE, text: "Inactive", icon: <CustomIcon name='inactive' />, label: INACTIVE_TEST_LABEL },
    { value: TEST_STATUS_COMPLETED, text: "Completed", icon: <CustomIcon name='completed' />, label: COMPLETED_TEST_LABEL },
  ];
};

// Test Type Text
export const getTestStatus = (type = TEST_STATUS_DRAFT) => getAllTestStatus().find((t) => t.value === type);

// Get Test Status Icon
export const getTestStatuslabelIcon = (status, icon = true) => {
  const labels = {
    [TEST_STATUS_DRAFT]: { icon: DRAFT_TEST_ICON, label: DRAFT_TEST_LABEL },
    [TEST_STATUS_ACTIVE]: { icon: ACTIVE_TEST_ICON, label: ACTIVE_TEST_LABEL },
    [TEST_STATUS_INACTIVE]: { icon: INACTIVE_TEST_ICON, label: INACTIVE_TEST_LABEL },
    [TEST_STATUS_EDIT]: { icon: DRAFT_TEST_ICON, label: DRAFT_TEST_LABEL },
    [TEST_STATUS_COMPLETED]: { icon: COMPLETED_TEST_ICON, label: COMPLETED_TEST_LABEL },
  };

  return icon ? (labels[status] ? labels[status].icon : DRAFT_TEST_ICON) : labels[status] ? labels[status].label : DRAFT_TEST_LABEL;
};

// Get Test Status Text
export const getTestStatuslabelText = (status) => {
  const labelText = {
    [TEST_STATUS_DRAFT]: "Draft",
    [TEST_STATUS_ACTIVE]: "Active",
    [TEST_STATUS_INACTIVE]: "Inactive",
    [TEST_STATUS_EDIT]: "In-Edit",
    [TEST_STATUS_COMPLETED]: "Completed",
  };

  return labelText[status] ? labelText[status] : "Draft";
};

// Test End Time Validation
export const isCorrectEndTime = (endTime) => dayjs(endTime) > dayjs();

// Returns true/false
export const isTestLaunchable = (
  test,
  randomCredits,
  isFreePlan,
  credits_response_total,
  hasResponseSubscription,
  cancel_at,
  isPreview = false
) => {
  if (!test || !test._id || !test.name) return false;
  if (!isCorrectEndTime(test?.endTime) || isQuestionnaireError(test)) return false;
  if (!isPreview && !isCorrectResponses(test, randomCredits, isFreePlan, credits_response_total, hasResponseSubscription, cancel_at)) {
    return false;
  }

  if (test.type === TEST_TYPE_TT) {
    if (test.tree) {
      // Valid if any home (root) node has children — supports multiple home nodes
      const hasChildren = test.tree.treeData?.some((root) => root?.children?.length > 0);
      if (!hasChildren) return false;
    } else {
      return false;
    }
  }

  if (test.type !== TEST_TYPE_CS) {
    if (test.tasks) {
      if (test.tasks.length === 0) return false;

      if (test.type === TEST_TYPE_TT) {
        let unAnswerTasks = test.tasks.filter((task) => !task.answers || task.answers.length === 0);
        if (unAnswerTasks.length > 0) return false;
      } else if (test.type === TEST_TYPE_PD) {
        let isPDError = test.tasks.some(
          (task) => !task.markers || task.markers.length === 0 || !task.description || task.description.length === 0
        );
        if (isPDError) return false;
      }
    } else {
      return false;
    }
  } else if (test.type === TEST_TYPE_CS) {
    const { type } = test.settings.card_sort;
    if (type === CARD_TYPE_CLOSE || type === CARD_TYPE_HYBRID) {
      return !isCardsError(test) && !isCategoriesError(test);
    } else if (type === CARD_TYPE_OPEN) {
      return !isCardsError(test);
    }
  }

  return true;
};

// Test Launch Text
export const getTestLaunchText = (status) => {
  const labelText = {
    [TEST_STATUS_DRAFT]: "Go Live",
    [TEST_STATUS_ACTIVE]: "Pause Study",
    [TEST_STATUS_INACTIVE]: "Resume study",
    [TEST_STATUS_EDIT]: "Go Live",
    [TEST_STATUS_COMPLETED]: "Completed",
  };

  return labelText[status] ? labelText[status] : "Go Live";
};

// Test Types
export const getTestTypes = (icon2Size = 28) => {
  const CustomIcon2 = (props) => <CustomIcon {...props} style={{ height: icon2Size, width: icon2Size }} />;

  return [
    {
      value: TEST_TYPE_CS,
      text: "Card Sorting",
      icon: "card_sorting",
      icon2: <CustomIcon2 name='cardsorting' />,
      product: PRODUCT_CARD_SORTING,
    },
    {
      value: TEST_TYPE_TT,
      text: "Tree Testing",
      icon: "tree_testing",
      icon2: <CustomIcon2 name='treetesting' />,
      product: PRODUCT_TREE,
    },
    {
      value: TEST_TYPE_PD,
      text: "Participatory Design",
      icon: "tutorial_participatory",
      icon2: <CustomIcon2 name='participatory' />,
      product: PRODUCT_PARTICIPATORY,
    },
  ];
};

// Test Type Text
export const getTestType = (type = TEST_TYPE_TT, icon2Size = 28) => getTestTypes(icon2Size).find((t) => t.value === type);

// Test Type Text
export const getTestTypeText = (type = TEST_TYPE_TT) => {
  const typeData = getTestTypes().find((t) => t.value === type);
  return typeData ? typeData.text : "";
};

// Test Device Types
export const getTestDeviceTypes = () => {
  return [
    { value: TEST_DEVICE_TYPE_DESKTOP, text: "Desktop", icon: "desktop" },
    { value: TEST_DEVICE_TYPE_SMARTPHONE, text: "Smart Phone", icon: "mobile alternate" },
  ];
};

// Test Device Type Text
export const getTestDeviceTypeText = (type = TEST_DEVICE_TYPE_SMARTPHONE) => {
  const typeData = getTestDeviceTypes().find((t) => t.value === type);
  return typeData ? typeData.text : "";
};

// Get Card Types
export const getCardTypes = () => [
  { value: CARD_TYPE_OPEN, text: "Open Card Sorting", short: "OPEN", icon: "card_open" },
  { value: CARD_TYPE_CLOSE, text: "Closed Card Sorting", short: "CLOSED", icon: "card_close" },
  { value: CARD_TYPE_HYBRID, text: "Hybrid Card Sorting", short: "HYBRID", icon: "card_mixed" },
];

// Get Card Type
export const getCardType = (type, short = false) => {
  const cardType = getCardTypes().find((c) => c.value === type);
  return cardType ? (short ? cardType.short : cardType.text) : "";
};

// Is there any errors in cards
export const isCardsError = (test) => {
  const { cards } = test.card_sort;
  // const { description } = test.settings.card_sort.card;

  if (cards.length < MIN_CARDS) return true;

  const item = cards.reduce(
    (data, card) => {
      let isError = false;
      if (data.isError) isError = true;

      const name = card.name;
      if (!name) isError = true;
      if (data.names.includes(name)) isError = true;
      // if (description && !card.desc.trim()) isError = true;
      return { isError, names: [...data.names, name] };
    },
    { isError: false, names: [] }
  );

  return item.isError;
};

// Is there any errors in categories
export const isCategoriesError = (test) => {
  const { categories } = test.card_sort;
  // const { description } = test.settings.card_sort.category;

  if (categories.length < MIN_CATEGORIES) return true;

  const item = categories.reduce(
    (data, category) => {
      if (category.type === UNCLEAR_CATEGORY) return data;

      let isError = false;
      if (data.isError) isError = true;

      const name = category.name;
      if (!name) isError = true;
      if (data.names.includes(name)) isError = true;
      // if (description && !category.desc.trim()) isError = true;
      return { isError, names: [...data.names, name] };
    },
    { isError: false, names: [] }
  );

  return item.isError;
};

// Survey question Error
export const isScreenOutError = (questions, type = SURVEY_TYPE_SCREENER) => {
  if (type !== SURVEY_TYPE_SCREENER) return false;

  return questions.reduce((result, q) => {
    if (result) return result;
    if (q.question_type !== QUEST_TYPE_TEXT && q.option.length === 0) return true;
    return false;
    // return q.option.findIndex((o) => o.screenOut) === -1; // Screen out is not required now. See Airtable 8A_july 2021 Release.
  }, false);
};

export const isQuestionnaireError = (test) => {
  if (!test._id || !test.settings) return false;

  const { survey, settings } = test;

  return Object.keys(survey).reduce((err, key) => {
    if (!err && settings.survey[key].include) {
      if (survey[key].length === 0) return true;

      return survey[key].reduce((err2, { label, option, question_type }) => {
        if (err2) return err2;

        return (
          !label ||
          ((question_type === QUEST_TYPE_RADIO || question_type === QUEST_TYPE_CHECKBOX) && option.some((o) => o.label === ""))
        );
      }, false);
    }
    return err;
  }, false);
};

// Survey Option Types
export const surveyOptionTypes = (surveyType = SURVEY_TYPE_SCREENER) => {
  const types = [
    { key: QUEST_TYPE_RADIO, text: "Radio Buttons", value: QUEST_TYPE_RADIO },
    { key: QUEST_TYPE_CHECKBOX, text: "Checkboxes", value: QUEST_TYPE_CHECKBOX },
  ];

  if (surveyType === SURVEY_TYPE_SCREENER) return types;
  return [
    { key: QUEST_TYPE_TEXT, text: "Text Answer", value: QUEST_TYPE_TEXT },
    ...types,
    // { key: QUEST_TYPE_RATING, text: 'Rating Slider', value: QUEST_TYPE_RATING },
  ];
};

// Get Survey Option Type
export const getOptionType = (surveyType = SURVEY_TYPE_SCREENER, key = QUEST_TYPE_RADIO) => {
  return surveyOptionTypes(surveyType).find((optType) => optType.key === key);
};

export const surveyTypes = () => [
  { key: SURVEY_TYPE_SCREENER, title: "Screener", value: 2, background: "bg-orange-1", bgColor: "#f2994a" },
  { key: SURVEY_TYPE_PRE, title: "Pre Study Survey", value: 0, background: "bg-purple-2", bgColor: "#d98df5" },
  { key: SURVEY_TYPE_POST, title: "Post Study Survey", value: 1, background: "bg-green-1", bgColor: "#b9c978" },
];

export const getSurveyTypeValue = (surveyKey) => {
  const surveyType = surveyTypes().find((s) => s.key === surveyKey);
  return surveyType.value;
};

export const shuffleSurveyQuestionOptions = (questions, shuffle = false) => {
  const newQuestions = shuffle ? shuffleArray(questions) : sortByKey(questions, "position");
  return newQuestions.map((quest) => {
    const { image, option, question } = quest?.settings || {};
    let images = quest?.image || [];
    if (images?.length) images = image?.shuffle ? shuffleArray(images) : sortByKey(images, "position");

    let options = quest?.option || [];
    const otherOption = options.find((o) => o.type === OPTION_TYPE_OTHERS);
    if (option?.shuffle) {
      if (otherOption) options = options.filter((o) => o.type !== OPTION_TYPE_OTHERS);
      options = shuffleArray(options);
      if (otherOption) options = [...options, otherOption];
    }

    return { ...quest, image: images, option: options, skippable: question?.optional || false };
  });
};

export const isSurveyEnabled = (test) =>
  surveyTypes().reduce(
    (enable, item) =>
      enable ? enable : test && test.settings && test.settings.survey[item.key] && test.settings.survey[item.key].include,
    false
  );

export const explanationLabels = [
  { label: "Ask for all", value: REQUIRE_EXPLANATION_YES, desc: "Compulsory for participants to provide the reasoning" },
  { label: "Optional", value: REQUIRE_EXPLANATION_OPTIONAL, desc: "Optional for participants to provide the reasoning" },
  { label: "Do not ask", value: REQUIRE_EXPLANATION_NO, desc: "Participants will not be asked to provide any reasoning" },
];

// Test End Time Validation
export const isCorrectResponses = (
  test,
  randomCredits,
  isFreePlan,
  credits_response_total,
  hasResponseSubscription,
  cancel_at,
  isCustomPlan = false,
  responsesCollected = {}
) => {
  if (!test._id || !test.settings || !test.settings.max_completed) return false;

  const { max_completed = 0 } = test?.settings || 0;
  const completedResponses = max_completed - (responsesCollected?.ownTesters || 0);

  const nonZeroResponses = max_completed > 0;
  const responsesValid = max_completed <= RESPONSES.MAX_COMPLETED;
  const estimatedPlatformCredits = Number(completedResponses) * Number(randomCredits);
  const insufficientPlatformCredits = isFreePlan && Math.abs(estimatedPlatformCredits) - Number(credits_response_total) > 0;
  const postpaidNotAllowed =
    (isCustomPlan || !hasResponseSubscription || (hasResponseSubscription && cancel_at)) &&
    Math.abs(estimatedPlatformCredits) - Number(credits_response_total) > 0;

  return nonZeroResponses && responsesValid && !insufficientPlatformCredits && !postpaidNotAllowed;
};

// Get Test Type using PRODUCT
export const getTestTypeByProduct = (product = "") => {
  const validProducts = [PRODUCT_TREE, PRODUCT_CARD_SORTING];
  if (!validProducts.includes(product)) return null;

  return getTestType(product === PRODUCT_TREE ? TEST_TYPE_TT : TEST_TYPE_CS);
};

// Get Error Tree Task
export const getErrorTask = (tasks) => tasks?.find((task) => !task?.description || !task?.answers?.length);
